/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Level_AdvancedInputs */

const en_us2_exercise_personal_strength_level_advanced = /** @type {(inputs: Exercise_Personal_Strength_Level_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced`)
};

const pt_br2_exercise_personal_strength_level_advanced = /** @type {(inputs: Exercise_Personal_Strength_Level_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançado`)
};

const es_419_exercise_personal_strength_level_advanced = /** @type {(inputs: Exercise_Personal_Strength_Level_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzado`)
};

const pt_pt2_exercise_personal_strength_level_advanced = /** @type {(inputs: Exercise_Personal_Strength_Level_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançado`)
};

const fr_fr2_exercise_personal_strength_level_advanced = /** @type {(inputs: Exercise_Personal_Strength_Level_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancé`)
};

const de_de2_exercise_personal_strength_level_advanced = /** @type {(inputs: Exercise_Personal_Strength_Level_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortgeschritten`)
};

const it_it2_exercise_personal_strength_level_advanced = /** @type {(inputs: Exercise_Personal_Strength_Level_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzato`)
};

/**
* | output |
* | --- |
* | "Advanced" |
*
* @param {Exercise_Personal_Strength_Level_AdvancedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_level_advanced = /** @type {((inputs?: Exercise_Personal_Strength_Level_AdvancedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Level_AdvancedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_level_advanced(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_level_advanced(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_level_advanced(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_level_advanced(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_level_advanced(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_level_advanced(inputs)
	return en_us2_exercise_personal_strength_level_advanced(inputs)
});
export { exercise_personal_strength_level_advanced as "exercise-personal.strength_level_advanced" }